import { render, staticRenderFns } from "./PowerGrammarFixContent.vue?vue&type=template&id=4cd2f886&scoped=true"
import script from "./PowerGrammarFixContent.vue?vue&type=script&lang=js"
export * from "./PowerGrammarFixContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd2f886",
  null
  
)

export default component.exports